/**
 * StepFooter — the action row at the bottom of every step card:
 * [Back]                       [Skip for now]  [Primary →]
 * Portal button styles (same as the settings pages' save / discard buttons).
 */
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

/** `message`: short left-aligned note on the button row (e.g. what is still missing).
 *  `hint`: neutral note next to Back (e.g. "you can do this later").
 *  `left`: any node for the left side of the row (e.g. a usage widget). */
export default function StepFooter({ onBack, onSkip, skipLabel, primaryLabel, onPrimary, busy = false, disabled = false, message = null, hint = null, left = null }) {
  const { t } = useTranslation();
  return (
    <div className="ac-footer">
      <div className="ac-footer-left">
        {left}
        {onBack && (
          <button type="button" className="ac-btn-ghost" onClick={onBack} disabled={busy}>
            <FontAwesomeIcon icon={faArrowLeft} /> {t('back')}
          </button>
        )}
        {hint && !message && <span className="ac-footer-hint">{hint}</span>}
        {message && (
          <span className="ac-footer-msg" role="alert">
            <FontAwesomeIcon icon={faCircleExclamation} /> {message}
          </span>
        )}
      </div>
      <div className="ac-footer-right">
        {onSkip && (
          <button type="button" className="ac-btn-ghost" onClick={onSkip} disabled={busy}>
            {skipLabel || t('ac_skip_step')}
          </button>
        )}
        <button type="button" className="ac-btn-primary" onClick={onPrimary} disabled={disabled || busy}>
          {primaryLabel}
          {busy ? <span className="ac-spinner ac-spinner-sm ac-spinner-light" /> : <FontAwesomeIcon icon={faArrowRight} />}
        </button>
      </div>
    </div>
  );
}
